import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Row, Col, Container, UncontrolledCollapse } from "reactstrap";
import logo from "assets/image/logo.png";
import Organization from "assets/image/Organization.png";
import Association from "assets/image/association.png";
import Business from "assets/image/Business.png";
import TehranRayan from "assets/image/tehran-rayan.png";

import "assets/styles/components/footer.scss";
import "assets/styles/components/lists.scss";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <Container>
        <Row
          className={"footer_list list border-list d-flex align-items-start"}
        >
          <Col xs="12" sm="12" lg="4" xl="4">
            <ul className="w-75">
              <li>
                <img className="pb-3" src={logo} alt="logo" />
              </li>
              <li>{t("Coinnic_market_about")}</li>
              <li className="d-flex flex-row justify-content-between">
                <img src={Organization} />
                <img src={Association} />
                <img src={Business} />
                <img src={TehranRayan} />
                <div className=" px-sm-3" />
              </li>
            </ul>
          </Col>
          <Col xs="12" sm="12" lg="2" xl="2">
            <div
              className="d-flex justify-content-between align-items-baseline d-block d-sm-none"
              id="toggler1"
            >
              <p className="fs-5 text-light  pt-3 ">{t("About Us")}</p>
              <i className="icon-chevron-down" />
            </div>
            <UncontrolledCollapse toggler="#toggler1">
              <ul>
                <li>
                  {" "}
                  <Link to="/about-us">{t("About Us")}</Link>
                </li>
                <li>
                  <Link to="/contact-us">{t("Contact Us")}</Link>
                </li>
                <li>
                  {" "}
                  <Link to="/rules">{t("Terms and Conditions")}</Link>
                </li>
                <li>
                  <Link to="faq">{t("Frequently Asked Questions")}</Link>
                </li>
              </ul>
            </UncontrolledCollapse>
            <ul className="d-none d-sm-block">
              <li className="pb-3">
                {" "}
                <span>{t("About Us")}</span>
              </li>
              <li>
                {" "}
                <Link to="/about-us">{t("About Us")}</Link>
              </li>
              <li>
                <Link to="/contact-us">{t("Contact Us")}</Link>
              </li>
              <li>
                {" "}
                <Link to="/rules">{t("Terms and Conditions")}</Link>
              </li>
              <li>
                <Link to="/faq">{t("Frequently Asked Questions")}</Link>
              </li>
            </ul>
          </Col>

          <Col xs="12" sm="12" lg="2" xl="2">
            <div
              className="d-flex justify-content-between align-items-baseline  d-block d-sm-none"
              id="toggler2"
            >
              <p className="fs-5 text-light">{t("Related Links")} </p>
              <i className="icon-chevron-down" />
            </div>
            <UncontrolledCollapse toggler="#toggler2">
              <ul>
                <li>
                  {" "}
                  <Link to="/security">{t("Security")}</Link>
                </li>
                <li>
                  {" "}
                  <Link to="/commission">{t("Commission")}</Link>
                </li>
                <li>
                  {" "}
                  <a href="https://demoapp.coinnik.market/app/markets/BTC_TMN">
                    {t("Trial version (demo)")}
                  </a>
                </li>
                <li>
                  {" "}
                  <Link to="/user-plan">{t("User levels")}</Link>
                </li>
              </ul>
            </UncontrolledCollapse>
            <ul className="d-none d-sm-block">
              <li className="pb-3">
                <span>{t("Related Links")}</span>
              </li>
              <li>
                {" "}
                <Link to="/security">{t("Security")}</Link>
              </li>
              <li>
                {" "}
                <Link to="/commission">{t("Commission")}</Link>
              </li>
              <li>
                {" "}
                <a href="https://demoapp.coinnik.market/app/markets/BTC_TMN">
                  {t("Trial version (demo)")}
                </a>
              </li>
              <li>
                {" "}
                <Link to="/user-plan">{t("User levels")}</Link>
              </li>
            </ul>
          </Col>
          <Col xs="12" sm="12" lg="4" xl="4">
            <ul>
              <li className="pb-3">
                <span>{t("Contact Us")}</span>
              </li>
              <li>
                <span className="fs-6 px-2">{t("info[at]coinnikmarket")}</span>
                <i className="icon-mail icon-mail-orange align-middle" />
              </li>
              <li>
                <i className="icon-headset align-middle" />
                <span className="fs-6 px-2">
                  {t("Contact number: 02147612345")}
                </span>
              </li>
              <li>
                <i className="icon-location align-middle" />
                <span className="fs-6 px-2">
                  {t("Unit 1, Diplomat Building, Ayatollah Kashani St, Tehran")}{" "}
                </span>
              </li>
            </ul>
          </Col>
        </Row>
        <Row className="py-4">
          <Col xs="12" lg="10" xl="10">
            <span className="text-white">
              {t(
                "All material and intellectual property rights of the website belong to coinnik Market"
              )}
            </span>
          </Col>
          <Col xs="12" lg="2" xl="2">
            <div className="d-flex footer_icon">
              <a href="https://www.instagram.com/coinnikmarket/ ">
                <i className="icon-instagram icon-instagram-md px-4" />{" "}
              </a>
              <a href="https://twitter.com/coinnikmarket">
                {" "}
                <i className="icon-twitter icon-twitter-md " />{" "}
              </a>
              <a href="mailito: info@coinnik.market" target="_self">
                <i className="icon-mail icon-mail-md px-4" />{" "}
              </a>
              <a href="https://www.linkedin.com/company/coinnikmarket">
                <i className="icon-linkdin icon-linkdin-md " />{" "}
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
